export function formatStrikePrice(orderLegs) {
  if (orderLegs.length > 4) return null
  return orderLegs
    .filter((order) => Boolean(order.strike))
    .map((order) => parseFloat(order.strike).toFixed(2))
    .join(' / ')
}
